import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';
import { useTaxIdConfig } from '../../hooks/use-tax-id-config';
import { messages } from './messages';

export const TaxIdentifierInformation = () => {
  const { taxIdName } = useTaxIdConfig();
  return (
    <Text
      formattedMessageValues={{
        a: (chunks) => <HelpArticleLink articleId={linkIDs.TaxIdentifierRequirements}>{chunks}</HelpArticleLink>,
        taxIdName,
      }}
      textType={TextType.Paragraph}
      value={messages.taxIdInformation}
    />
  );
};
